import { render, staticRenderFns } from "./salelistNew.vue?vue&type=template&id=a2acd676&scoped=true&"
import script from "./salelistNew.vue?vue&type=script&lang=js&"
export * from "./salelistNew.vue?vue&type=script&lang=js&"
import style0 from "./salelistNew.vue?vue&type=style&index=0&id=a2acd676&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2acd676",
  null
  
)

export default component.exports